import config from './config';
import { handleResponse } from './handle-response';
import { checkToken, authHeader } from './helpers'

export const userCataloguesService = {
	list,
	listReports,
	listOwnedReportIds,
}
async function list(search = "") {
	await checkToken();

	let url = `${config.apiUrl}/user-catalogues/`;
	if (search && search.trim() !== "") {
		url += `?search=${encodeURIComponent(search.trim())}`;
	}

	const requestOptions = { method: 'GET', headers: authHeader() };
	return fetch(url, requestOptions)
		.then(handleResponse)
		.then(data => data);
}

async function listReports(userCatalogueId) {
	await checkToken();
	const requestOptions = { method: 'GET', headers: authHeader() };
	return fetch(
		`${config.apiUrl}/user-catalogues/${userCatalogueId}/reports/?limit=10000`,
		requestOptions
	)
		.then(handleResponse)
		.then(data => data);
}

async function listOwnedReportIds(catalogueId) {
	await checkToken();
	const requestOptions = { method: 'GET', headers: authHeader() };
	let url = `${config.apiUrl}/catalogues/${catalogueId}/owned-report-ids/?limit=1000`;
	const ids = [];
	while (url) {
		const page = await fetch(url, requestOptions).then(handleResponse);
		ids.push(...(page.results || []));
		url = page.next;
	}
	return ids;
}
